import { html } from "lit";
import { localeSelection, toolbox, breadcrumb } from "./header-partials";

export const storyArgs = {
    withToolbox: true,
    withBreadcrumb: false,
    header: "website",
    is100Years: false,
};

export const Template = (args = storyArgs) => {
    return html`
        <ux-iws-header
            type="trumpf"
            class="${args.is100Years ? `ux-iws-header--100` : ``}"
        >
            <div slot="header" class="ux-iws-header__main-wrapper">
                <a class="ux-iws-header__logo" title="TRUMPF logo" href="">
                    <img
                        src="https://www.trumpf.com/typo3conf/ext/trumpf_package/Resources/Public/Images/nav/logo.png"
                        alt="Trumpf"
                    />
                </a>
                ${localeSelection(args)}
                <div class="ux-iws-header__navigation-wrapper">
                    <ux-iws-nav back-button-text="Zurück">
                        <nav slot="navigation">
                            <ul class="ux-iws-nav__lvl1">
                                <li class="ux-iws-nav__lvl1-item">
                                    <a href="">Produkte</a>
                                    <ul class="ux-iws-nav__lvl2">
                                        <li
                                            class="ux-iws-nav__lvl2-item ux-iws-nav__lvl2-item--overview"
                                        >
                                            <a href="">Übersicht Produkte</a>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Maschinen & Systeme</a>
                                            <div
                                                class="ux-iws-nav__lvl3-wrapper"
                                            >
                                                <ul class="ux-iws-nav__lvl3">
                                                    <li
                                                        class="ux-iws-nav__lvl3-item ux-iws-nav__lvl3-item--overview"
                                                    >
                                                        <a href=""
                                                            >Übersicht VCSEL
                                                            Lösungen &
                                                            Photodioden</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Lorem Ipsum</a
                                                        >
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Laser</a>
                                            <div
                                                class="ux-iws-nav__lvl3-wrapper"
                                            >
                                                <ul class="ux-iws-nav__lvl3">
                                                    <li
                                                        class="ux-iws-nav__lvl3-item ux-iws-nav__lvl3-item--overview"
                                                    >
                                                        <a href=""
                                                            >Übersicht VCSEL
                                                            Lösungen &
                                                            Photodioden</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Bearbeitungsoptiken</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Beschriftungslaser</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href="">CO2-Laser</a>
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Diodenlaser</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >EUV Drive Laser</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href="">EUV Laser</a>
                                                    </li>
                                                </ul>
                                                <ul class="ux-iws-nav__lvl3">
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Gepulste Laser</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Kurz- und
                                                            Ultrakurzpulslaser</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Scheibenlaser</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href="">Sensorik</a>
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Technologiepakete</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Wissenschaftslaser</a
                                                        >
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href=""
                                                >VCSEL Lösungen & Photoioden</a
                                            >
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Leistungselektronik</a>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Elektrowerkzeuge</a>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">TRUMark Series</a>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Software</a>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Services</a>
                                        </li>
                                        ${args.withToolbox
                                            ? html`${toolbox()}`
                                            : ``}
                                    </ul>
                                </li>
                                <li class="ux-iws-nav__lvl1-item">
                                    <a href="">Lösungen</a>
                                    <ul class="ux-iws-nav__lvl2">
                                        <li
                                            class="ux-iws-nav__lvl2-item ux-iws-nav__lvl2-item--overview"
                                        >
                                            <a href="">Übersicht Lösungen</a>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Smart Factory</a>
                                            <div
                                                class="ux-iws-nav__lvl3-wrapper"
                                            >
                                                <ul class="ux-iws-nav__lvl3">
                                                    <li
                                                        class="ux-iws-nav__lvl3-item ux-iws-nav__lvl3-item--overview"
                                                    >
                                                        <a href=""
                                                            >Übersicht Smart
                                                            Factory</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item ux-iws-nav__lvl3-item--subheadline"
                                                    >
                                                        Subheadline 1
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Smart Factory</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Smart Factory
                                                            Consulting</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Smart Factory
                                                            Chicago</a
                                                        >
                                                    </li>
                                                </ul>
                                                <ul class="ux-iws-nav__lvl3">
                                                    <li
                                                        class="ux-iws-nav__lvl3-item ux-iws-nav__lvl3-item--subheadline"
                                                    >
                                                        Schritte zur Smart
                                                        Factory
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Einfach anfangen</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Schrittweise
                                                            erweitern</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Komplett
                                                            vernetzt</a
                                                        >
                                                    </li>
                                                </ul>
                                                <ul class="ux-iws-nav__lvl3">
                                                    <li
                                                        class="ux-iws-nav__lvl3-item ux-iws-nav__lvl3-item--subheadline"
                                                    >
                                                        Solutions / Use Cases
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Losgröße 1</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Transparent mit
                                                            Track & Trace</a
                                                        >
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Anwendungen</a>
                                            <div
                                                class="ux-iws-nav__lvl3-wrapper"
                                            >
                                                <ul class="ux-iws-nav__lvl3">
                                                    <li
                                                        class="ux-iws-nav__lvl3-item ux-iws-nav__lvl3-item--overview"
                                                    >
                                                        <a href=""
                                                            >Übersicht XY</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Lorem Ipsum</a
                                                        >
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Branchen</a>
                                            <div
                                                class="ux-iws-nav__lvl3-wrapper"
                                            >
                                                <ul class="ux-iws-nav__lvl3">
                                                    <li
                                                        class="ux-iws-nav__lvl3-item ux-iws-nav__lvl3-item--overview"
                                                    >
                                                        <a href=""
                                                            >Übersicht XY</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Lorem Ipsum</a
                                                        >
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href=""
                                                >Vorteile TRUMPF Maschinen</a
                                            >
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Erfolgsgeschichten</a>
                                        </li>
                                        ${args.withToolbox
                                            ? html`${toolbox()}`
                                            : ``}
                                    </ul>
                                </li>
                                <li class="ux-iws-nav__lvl1-item">
                                    <a href="">Unternehmen</a>
                                    <ul class="ux-iws-nav__lvl2">
                                        <li
                                            class="ux-iws-nav__lvl2-item ux-iws-nav__lvl2-item--overview"
                                        >
                                            <a href="">Übersicht Unternehmen</a>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">TRUMPF Gruppe</a>
                                            <div
                                                class="ux-iws-nav__lvl3-wrapper"
                                            >
                                                <ul class="ux-iws-nav__lvl3">
                                                    <li
                                                        class="ux-iws-nav__lvl3-item ux-iws-nav__lvl3-item--overview"
                                                    >
                                                        <a href=""
                                                            >Übersicht TRUMPF
                                                            Gruppe</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Geschäftsführung</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Unternehmensprofil</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Aufsichtsrat</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Meilensteine in der
                                                            TRUMPF Gruppe</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Unternehmensgrundsätze</a
                                                        >
                                                    </li>
                                                </ul>
                                                <ul class="ux-iws-nav__lvl3">
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href="">Qualität</a>
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href="">SYNCHRO</a>
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Weitere Unternehmen
                                                            in der TRUMPF
                                                            Gruppe</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Financial
                                                            Services</a
                                                        >
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Verantwortung</a>
                                            <div
                                                class="ux-iws-nav__lvl3-wrapper"
                                            >
                                                <ul class="ux-iws-nav__lvl3">
                                                    <li
                                                        class="ux-iws-nav__lvl3-item ux-iws-nav__lvl3-item--overview"
                                                    >
                                                        <a href=""
                                                            >Übersicht XY</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Lorem Ipsum</a
                                                        >
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Geschäftsbericht</a>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Standorte</a>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href=""
                                                >Veranstaltungen & Termine</a
                                            >
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Lieferanten</a>
                                        </li>
                                        ${args.withToolbox
                                            ? html`${toolbox()}`
                                            : ``}
                                    </ul>
                                </li>
                                <li class="ux-iws-nav__lvl1-item">
                                    <a href="">Newsroom</a>
                                </li>
                                <li class="ux-iws-nav__lvl1-item">
                                    <a href="">Karriere</a>
                                    <ul class="ux-iws-nav__lvl2">
                                        <li
                                            class="ux-iws-nav__lvl2-item ux-iws-nav__lvl2-item--overview"
                                        >
                                            <a href="">Übersicht Karriere</a>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Startseite</a>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href=""
                                                >TRUMPF als Arbeitgeber</a
                                            >
                                            <div
                                                class="ux-iws-nav__lvl3-wrapper"
                                            >
                                                <ul class="ux-iws-nav__lvl3">
                                                    <li
                                                        class="ux-iws-nav__lvl3-item ux-iws-nav__lvl3-item--overview"
                                                    >
                                                        <a href="">Übersicht</a>
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >TRUMPF als
                                                            Arbeitgeber</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Leistungen und
                                                            Angebote</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href="">Vielfalt</a>
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Entwicklungsmöglichkeiten</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Internationales
                                                            Arbeiten</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href="">Umwelt 1</a>
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href="">Umwelt 2</a>
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href="">Umwelt 3</a>
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href="">Umwelt 4</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Zielgruppen</a>
                                            <div
                                                class="ux-iws-nav__lvl3-wrapper"
                                            >
                                                <ul class="ux-iws-nav__lvl3">
                                                    <li
                                                        class="ux-iws-nav__lvl3-item ux-iws-nav__lvl3-item--overview"
                                                    >
                                                        <a href=""
                                                            >Übersicht XY</a
                                                        >
                                                    </li>
                                                    <li
                                                        class="ux-iws-nav__lvl3-item"
                                                    >
                                                        <a href=""
                                                            >Lorem Ipsum</a
                                                        >
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Bewerbungsprozess</a>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Stellenangebote</a>
                                        </li>
                                        <li class="ux-iws-nav__lvl2-item">
                                            <a href="">Menschen bei TRUMPF</a>
                                        </li>
                                        ${args.withToolbox
                                            ? html`${toolbox()}`
                                            : ``}
                                    </ul>
                                </li>
                                <li class="ux-iws-nav__lvl1-item">
                                    <a href="">Nachhaltichkeit</a>
                                </li>
                            </ul>
                        </nav>
                        <div slot="navigation-meta" class="ux-iws-nav__meta">
                            <div class="ux-iws-nav__meta-container-header">
                                ${metaNavigationFirst()}
                            </div>
                            <div class="ux-iws-nav__meta-container-burger">
                                <ux-iws-nav-burger
                                    menu-text-open="Menü"
                                    menu-text-close="Schliessen"
                                ></ux-iws-nav-burger>
                            </div>
                        </div>
                    </ux-iws-nav>
                </div>
            </div>
            ${args.withBreadcrumb ? html`${breadcrumb()}` : ``}
            <div
                slot="header-dropdown"
                id="ux-iws-header__dropdown-container"
                class="ux-iws-header__dropdown-container"
            >
                <div class="ux-iws-header__meta-container-dropdown">
                    ${metaNavigationSecond()}
                </div>
            </div>
        </ux-iws-header>
    `;
};

function metaNavigationFirst() {
    return html`
        <ux-iws-navigation-meta>
            <div
                class="ux-iws-navigation-meta__item ux-iws-navigation-meta__item--mobile-visible"
            >
                <div class="ux-iws-navigation-meta__search">
                    <ux-icon name="magnifier"></ux-icon>
                    <span class="ux-iws-navigation-meta__link-text">Suche</span>
                    <form
                        class="ux-iws-navigation-meta__search__form"
                        action="/no_cache/de_DE/meta/suche/"
                    >
                        <input
                            type="search"
                            name="q"
                            class="ux-iws-navigation-meta__search__input"
                            placeholder="Suche"
                            tabindex="0"
                            autocomplete="off"
                        />
                        <button
                            type="button"
                            class="ux-iws-navigation-meta__search__close"
                            tabindex="0"
                        >
                            <ux-icon name="close"></ux-icon>
                        </button>
                    </form>
                </div>
            </div>
            <div class="ux-iws-navigation-meta__item">
                <a href="#">
                    <span class="ux-iws-navigation-meta__icon-box">
                        <ux-icon name="nav-contact"></ux-icon>
                    </span>
                    <span class="ux-iws-navigation-meta__link-text"
                        >Kontakt</span
                    >
                </a>
            </div>
            <div class="ux-iws-navigation-meta__item">
                <a href="javascript:void(0)" name="profile">
                    <span class="ux-iws-navigation-meta__icon-box">
                        <ux-icon name="avatar-circle" weight="bold"></ux-icon>
                    </span>
                    <span class="ux-iws-navigation-meta__link-text"
                        >Profil</span
                    >
                </a>
                <ux-tooltip tooltip-target="a[name='profile']" align="top">
                    <div>
                        <button class="button-close" data-ux-tooltip-close>
                            <ux-icon
                                name="close"
                                class="ux-icon hydrated"
                            ></ux-icon>
                        </button>
                        <a href="#" class="ux-tooltip__link-item"
                            >Meine Daten</a
                        >
                        <a href="#" class="ux-tooltip__link-item"
                            >Administration</a
                        >
                        <a
                            href="#"
                            class="ux-tooltip__link-item"
                            data-trigger-guided-tour="start"
                            >User Guide</a
                        >
                        <a href="#" class="ux-tooltip__link-item">Logout</a>
                    </div>
                </ux-tooltip>
            </div>
            <div class="ux-iws-navigation-meta__item">
                <a
                    href="javascript:void(0)"
                    data-meta-navigation="locale-selection"
                >
                    <span class="ux-iws-navigation-meta__icon-box">
                        <ux-icon name="nav-globe"></ux-icon>
                    </span>
                    <span class="ux-iws-navigation-meta__link-text"
                        >Deutschland | DE</span
                    >
                </a>
            </div>
            <div
                class="ux-iws-navigation-meta__item ux-iws-navigation-meta__item--top-border"
            >
                <a href="#">
                    <span class="ux-iws-navigation-meta__icon-box">
                        <ux-icon name="cube"></ux-icon>
                    </span>
                    <span class="ux-iws-navigation-meta__link-text"
                        >GO to mytrumpf</span
                    >
                </a>
            </div>
        </ux-iws-navigation-meta>
    `;
}

function metaNavigationSecond() {
    return html`
        <ux-iws-navigation-meta>
            <div class="ux-iws-navigation-meta__item">
                <a href="#">
                    <span class="ux-iws-navigation-meta__icon-box">
                        <ux-icon name="nav-contact"></ux-icon>
                    </span>
                    Contact
                </a>
            </div>
            <div class="ux-iws-navigation-meta__item">
                <a
                    href="javascript:void(0)"
                    data-meta-navigation="locale-selection"
                >
                    <span class="ux-iws-navigation-meta__icon-box">
                        <ux-icon name="nav-globe"></ux-icon>
                    </span>
                    Deutschland | DE
                </a>
            </div>
            <span class="ux-iws-navigation-meta__item__flex-break"></span>
            <div class="ux-iws-navigation-meta__item">
                <a class="ux-button ux-button__trumpf" href="#">
                    go to mytrumpf
                    <ux-icon name="arrow-right"></ux-icon>
                </a>
            </div>
        </ux-iws-navigation-meta>
    `;
}
